const customerRecoverMutation = /* GraphQL */ `
	mutation customerRecover($email: String!) {
		customerRecover(email: $email) {
			customerUserErrors {
				message
				field
				code
			}
		}
	}
`

export default customerRecoverMutation
